/* eslint-disable */
import anne from '../assets/svg/testimonials/anne.jpeg'
import ken from '../assets/svg/testimonials/ken.jpeg'
import hema from '../assets/svg/testimonials/hema.jpeg'
import obrien from '../assets/svg/testimonials/obrien.jpeg'
import cherryl from '../assets/svg/testimonials/cherryl.jpeg'
import annekhi from'../assets/svg/testimonials/annekhi.jpeg'
export const testimonialsData = [
    {
        id: 1,
        name: 'William KIbet',
        title: 'Cloud Factory Citizen Training Captain',
        text: "Working with Virsail as a data analyst has been a continous learning session for me as he is a  very resourceful colleague both tech-wise and soft skill wise.",
        image: obrien
        
    },
    {
        id: 2,
        name: 'Shanice Khanali',
        title: 'KCB Group Ltd Head Of Channels Department',
        text: "This is a very talented colleague, you can take my word.",
        image: annekhi
    },
    {
        id: 3,
        name: 'Rehema Atieno',
        title: 'Cloud Factory Citizen Training Captain',
        text: "One of the most resourceful workmates I have worked with.",
        image: hema
    },
    {
        id: 4,
        name: 'Ken Muli',
        title: 'KCB Group Ltd Head Of IT Department',
        text: "I have worked with this man I can assure you the level of dedication he has shown over his time with us at KCB Group is incredible.",
        image: ken
    },
    {
        id: 5,
        name: 'Anne Mwangi',
        title: 'Contractee',
        text: 'It is never a dull time around Virsail.',
        image: anne
    },
    {
        id: 6,
        name: 'Cherryl Walubengo',
        title: 'Developer',
        text: "I have worked with Virsail for a while now .He's the best trust me!",
        image: cherryl
    }
]

